import type { ConfluenceWhiteboard } from '../../types';

export const isConfluenceWhiteboard = (entity: any): entity is ConfluenceWhiteboard => {
	return entity.__typename === 'ConfluenceWhiteboard';
};

export const getConfluenceWhiteboardLink = (whiteboard: ConfluenceWhiteboard): string | null => {
	const { base, webUi } = whiteboard.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
